// extracted by mini-css-extract-plugin
export default {"header":"pagination_header__R-2nu","btn":"pagination_btn__JWwwA","text":"pagination_text__H2nf3"};